module.exports = __webpack_public_path__ + "img/0Q3B0162_L_Black.4aadec6b.jpg";